import { render, staticRenderFns } from "./FastInsert.vue?vue&type=template&id=ce50aa32&"
import script from "./FastInsert.vue?vue&type=script&lang=js&"
export * from "./FastInsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports